import { useQuery } from '@apollo/client';
import type { UseProviderFetch } from '@openx/components-provider/lib/utils/context/ProviderHookTypes.ts';
import { GetProviderDocument } from '../../../graphql/query/providers/GetProvider.generated.tsx';

export const useProviderFetch: UseProviderFetch = providerId => {
  const {
    data: { provider_by_pk: provider } = {},
    loading,
    refetch,
  } = useQuery(GetProviderDocument, { skip: !providerId, variables: { id: providerId } });

  return {
    loading,
    provider,
    refetch,
  };
};
